import {apsCommands} from "../../shared/dto/aps.commands";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as angular from 'angular';
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

export interface DataPointService {
  get(plantId: string): angular.IPromise<apsViewModels.DataPointDetail[]>;
  add(command: apsCommands.AddDataPoint): angular.IPromise<any>;
  update(command: apsCommands.UpdateDataPoint): angular.IPromise<any>;
  remove(command: apsCommands.RemoveDataPoint): angular.IPromise<any>;
  validateFormula(request: apsViewModels.FormulaValidationRequest): angular.IPromise<string[]>;
  calculateFormula(request: apsViewModels.CalculationRequest): angular.IPromise<number>;
}

export default angular
  .module('aps.services.dataPoint', [HttpServiceName])
  .service('dataPointService', (
    httpService: HttpService
  ): DataPointService => {
    return {
      get: (plantId: string): angular.IPromise<apsViewModels.DataPointDetail[]> =>
        httpService.get<apsViewModels.DataPointDetail[]>(Endpoints.DATAPOINTS, {plantId: plantId}),

      add: (command: apsCommands.AddDataPoint): angular.IPromise<any> =>
        httpService.post(Endpoints.DATAPOINTS, command),

      update: (command: apsCommands.UpdateDataPoint): angular.IPromise<any> =>
        httpService.put(Endpoints.DATAPOINTS, command),

      remove: (command: apsCommands.RemoveDataPoint): angular.IPromise<any> =>
        httpService.delete(Endpoints.DATAPOINTS + '/' + command.id,
          { plantId: command.plantId, plantLocationId: command.plantLocationId }),

      validateFormula: (request: apsViewModels.FormulaValidationRequest): angular.IPromise<string[]> =>
        httpService.post<string[]>(Endpoints.DATAPOINTS_VALIDATE, request),

      calculateFormula: (request: apsViewModels.CalculationRequest): angular.IPromise<number> =>
        httpService.post<number>(Endpoints.DATAPOINTS_CALCULATE, request)
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/services/dataPoints/dataPoints.service.ts